import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomError, GlobalAlert } from '@Typings/index';

const initialState: GlobalAlert = {
  isVisible: false,
  error: undefined,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    resetAlert: (state) => {
      state.isVisible = false;
      state.error = undefined;
    },
    showAlert: (state, action: PayloadAction<CustomError>) => {
      // show the global error snackbar
      state.isVisible = true;
      state.error = { ...action.payload };
    },
    hideAlert: (state) => {
      // hide the global alert snackbar
      state.isVisible = false;
    },
  },
});

const { actions, reducer } = alertSlice;
// Extract and export each action creator by name
export const { showAlert, hideAlert, resetAlert } = actions;
export default reducer;
